/**
 * Lab bet-ticker Profit/Liability:
 * `(odds − 1) * matchedAmt` (same for BACK and LAY).
 * Line Session: odds = Odds Placed / betRate (2), never runs (Odds Matched).
 */
export function tickerProfitLiability(
  oddsMatched: number,
  matchedAmount: number,
  opts?: { lineSession?: boolean; oddsPlaced?: number },
): number {
  if (!Number.isFinite(matchedAmount)) return 0
  const odds = opts?.lineSession
    ? Number.isFinite(opts.oddsPlaced) && (opts.oddsPlaced as number) > 0
      ? (opts.oddsPlaced as number)
      : 2
    : oddsMatched
  if (!Number.isFinite(odds)) return 0
  return (odds - 1) * matchedAmount
}
